/*
 * AuraGardyn analytics bridge.
 *
 * Subscribes to Dawn's PUB_SUB_EVENTS.cartUpdate and pushes GA4-shaped
 * events to window.dataLayer for GTM / GA4 to pick up. Also wires
 * begin_checkout on the standard Dawn checkout buttons.
 *
 * Only fires if the user has accepted KVKK consent
 * (localStorage.kvkkConsent === 'accepted'). The kvkk:choice event
 * (dispatched from auragardyn.js on banner click) flips the gate on
 * after acceptance without requiring a page reload.
 *
 * Loaded as a classic <script defer> after Dawn's constants.js +
 * pubsub.js, so PUB_SUB_EVENTS / subscribe / publish are globals.
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  var consentAccepted = false;

  function readConsent() {
    try {
      consentAccepted = localStorage.getItem('kvkkConsent') === 'accepted';
    } catch (_) {
      consentAccepted = false;
    }
  }
  readConsent();

  document.addEventListener('kvkk:choice', function (event) {
    consentAccepted = event.detail && event.detail.choice === 'accepted';
  });

  function push(event) {
    if (!consentAccepted) return;
    window.dataLayer.push(event);
  }

  function lineItemToGa4(item) {
    return {
      item_id: item.product_id || item.id,
      item_variant: item.variant_id || item.id,
      item_name: item.product_title || item.title,
      price: (item.final_price || item.price || 0) / 100,
      quantity: item.quantity || 1,
      item_brand: item.vendor,
    };
  }

  function onCartUpdate(payload) {
    if (!payload || !payload.cartData) return;
    var cartData = payload.cartData;

    if (payload.source === 'product-form' || payload.source === 'quick-add') {
      var addedItems = (cartData.items || []).filter(function (item) {
        return String(item.variant_id || item.id) === String(payload.productVariantId);
      });
      push({
        event: 'add_to_cart',
        ecommerce: {
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY',
          value: cartData.total_price ? cartData.total_price / 100 : undefined,
          items: addedItems.map(lineItemToGa4),
        },
      });
    }
  }

  function onCheckoutClick() {
    push({
      event: 'begin_checkout',
      ecommerce: {
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY',
      },
    });
  }

  function wire() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target.closest('[name="checkout"], [data-checkout-button]');
        if (target) onCheckoutClick();
      },
      true,
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
